import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanText'
})

export class CleanTextPipe implements PipeTransform {
    constructor() {}

    transform(key: string, args?) : string {
        return key.replace(/_/g, ' ');
    }
}
